















import { Vue, Component, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: mapState(['partner']),
})
export default class ErrorMessage extends Vue {
  public partner!: any;
  @Prop() private readonly errorCode!: string;

}
